import React from 'react'
import { Modal, Button } from 'react-bootstrap'

export default class LogoutModal extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.handleShow = this.handleShow.bind(this);
    this.state = {show: this.props.show}
  }

  handleShow() {
    this.setState({ show: true });
  }

  render() {
    return (
      <div>
        <Button bsStyle="primary" className='delete-entry action-btn' onClick={this.handleShow}>
        </Button>
        <Modal
          {...this.props}
          show={this.state.show}
          onHide={this.props.hideLogoutModal}
          dialogClassName="custom-modal"
          backdrop={false}>
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-lg">
             Uitloggen
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>
             Wilt u uitloggen?
            </p>
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle="primary" onClick={this.props.logout}>Uitloggen</Button>
            <Button onClick={this.props.hideLogoutModal}>Annuleren</Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/LogoutModal.js